import { useDispatch } from "react-redux";
import { loadPath } from "../Path/PathReducer";
import { loadRoom } from "../Room/RoomReducer";

export const Dispatcher = () => {
  const dispatch = useDispatch();
  dispatch(loadRoom());
  dispatch(loadPath());
};
